module.exports = "../../../../platform/assets/pageMainIcon/business_danjuweihulei3.svg";